import { render } from "./AddFaq.vue?vue&type=template&id=9c472826"
import script from "./AddFaq.vue?vue&type=script&lang=js"
export * from "./AddFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__